export const COMPARISON_AUTOMATION_IDS = {
    section: "conversion-rate-comparison-section",
    sectionPop: "conversion-rate-comparison-pop-section",
    card: "conversion-rate-comparison-card",
    cardPop: "conversion-rate-comparison-pop-card",
    lockedCta: "conversion-rate-comparison-card-locked-cta",
    lockedCtaPop: "conversion-rate-comparison-pop-card-locked-cta",
    table: "conversion-rate-comparison-table",
    tablePop: "conversion-rate-comparison-pop-table",
} as const;

export const comparisonRowAutomationId = (automationPrefix: string, categoryId: string, suffix: string): string =>
    `${automationPrefix}-row-${categoryId}-${suffix}`;
